import Vue from 'vue'
import { Swiper as SwiperClass, Lazy, Mousewheel, Keyboard, Navigation } from 'swiper/js/swiper.esm'
import getAwesomeSwiper from 'vue-awesome-swiper/dist/exporter'
import 'swiper/css/swiper.css'

SwiperClass.use([Lazy, Mousewheel, Keyboard, Navigation])
Vue.use(getAwesomeSwiper(SwiperClass))
